import cx from 'classnames'

const AppWrapper = ({children, classNames, styles}) => (<>
  <div className="app-main">
    <div className={cx("app-main__wrapper", classNames)} style={styles}>
      {children}
    </div>
  </div>
</>)

export default AppWrapper